import React, { useState } from 'react';
import axios from 'axios';
import CommonModal from '../../common_jsx/CommonModal'
import config from '../../config.js';

function DataSourceUpdateModal({ savedsource, showUpdateModal, setShowUpdateModal, setConductReload }) {

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [isLoading, setIsLoading] = useState(false);
    // Logic for creating object for POST request and submitting to the add filfillment source endpoint
    const HandleSubmit = async (e, savedsource) => {
        e.preventDefault();
        // Start the loading animation
        setIsLoading(true);
        // Close the Previous Alert if applicable
        setShowAlert(false);
        // Next few lines of code is getting the form data ready for submission to the add-fulfillment sources request
        const form = e.target;
        const formData = new FormData(form);
        const formObject = Object.fromEntries(formData.entries());
        // Separate the 'name' field
        const { name, ...configuration } = formObject;
        // Construct the desired object structure
        const formattedData = {
            configuration: configuration,
            name: name,
            source: {
                id: savedsource.id,
                name: savedsource.source.name,
            }
        };
        // Extracting the service_account_key as a string. It needs to be changed to a JSON object
        const serviceAccountKeyString = formattedData.configuration.service_account_key;
        try {
            // TODO: Check if the master configuration has data type as "json" for any field, then prase all those fields. We should not specifically look for "serviceAccountKey".
            // Attempting to parse the string to an object
            const serviceAccountKeyObject = JSON.parse(serviceAccountKeyString);
            // If parsing is successful, assigning the parsed object back to the original data structure
            formattedData.configuration.service_account_key = serviceAccountKeyObject;
        } catch (error) {
            // If parsing fails, log the error (or handle it as needed)
            console.error("Parsing error: ", error);
        }
        const config_home = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('token')
            }
        };
        // Put request for updating database
        try {
            const response = await axios.put(`${config.serviceUrl}/fulfillment-source/update`, formattedData, config_home);
            // Set success alert
            setAlertMessage(response.data.message);
            setAlertType('success');
            setShowAlert(true);
            setConductReload(prevState => !prevState);
        } catch (error) {
            console.error('There was an error!', error);
            // Set error alert
            setAlertMessage(error.message);
            setAlertType('danger');
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const updatebody = (
        <>
            {showAlert && (
                <div className={`px-4 py-3 rounded mb-4 ${
                    alertType === 'success' 
                        ? 'bg-green-100 border border-green-400 text-green-700' 
                        : 'bg-red-100 border border-red-400 text-red-700'
                }`} role="alert">
                    {alertMessage}
                </div>)}
            <form onSubmit={(e) => HandleSubmit(e, savedsource)}>
                <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Name</label>
                    <input type="text" name="name" className="w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent" defaultValue={savedsource.name} required />
                </div>
                {Object.entries(savedsource.configuration).map(([key, value], index) => {
                    // Check if the value is an object and convert it to a string if necessary
                    const stringValue = (typeof value === 'object' && value !== null) ? JSON.stringify(value) : value;
                    return (
                        <div className="mb-4" key={index}>
                            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">{key}</label>
                            <input type="text" name={key} className="w-full px-3 py-2 border border-gray-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent" defaultValue={stringValue} required />
                        </div>
                    );
                })}
                <button type="submit" className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2" disabled={isLoading}>
                    {isLoading &&
                        <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" role="status">
                            <span className="sr-only"></span>
                        </div>}
                    {isLoading ? ' Working...' : 'Update'}
                </button>
            </form>
        </>
    )

    const updateDataSourceContent = {
        heading: "Update Data Source",
        body: updatebody,
        isLoading: isLoading
    }

    return (
        <CommonModal
            show={showUpdateModal}
            setShow={setShowUpdateModal}
            modalContent={updateDataSourceContent}
        />
    )
}

export default DataSourceUpdateModal
